import { render, staticRenderFns } from "./cardImport.vue?vue&type=template&id=534c000b&scoped=true&"
import script from "./cardImport.vue?vue&type=script&lang=js&"
export * from "./cardImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c000b",
  null
  
)

export default component.exports